module.exports = __webpack_public_path__ + "static/media/119.627761fb.svg";